import { instance } from "@/apis";
import { useQuery } from "@tanstack/react-query";

interface ChatStreamActiveData {
  active: boolean;
  chatType?: string;
}

const useChatStreamActiveQuery = (chatId: string | undefined, enabled: boolean) => {
  return useQuery({
    queryKey: ["chatStreamActive", chatId],
    queryFn: async () => {
      const res = await instance.get<{ data: ChatStreamActiveData }>(`/api/df/user/chat/isg/stream/active/${chatId}`);
      return (res.data as any)?.data as ChatStreamActiveData;
    },
    enabled: !!chatId && enabled,
    refetchInterval: (query) => (query.state.data?.active ? 10000 : false),
  });
};

export default useChatStreamActiveQuery;
